<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 1.tabbar-container-start -->
    <tabbar :tabbarIndex="1"></tabbar>
    <!-- 1.tabbar-container-end -->

    <!-- 2.main-container-start -->
    <div class="main">
      <div class="top">
        <span class="text">退货订单详情</span>
        <div class="sj"></div>
      </div>
      <div class="bottom borderShadow">
        <div class="info">
          <div class="top">退货基本信息</div>
          <div class="bottom">
            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">申请时间:</div>
                <div class="right">
                  {{ currentPageInfo.createTime || "暂无" }}
                </div>
              </div>
              <div class="item flexStyle2">
                <div class="left">退货状态:</div>
                <div class="right right1">
                  <span>{{ getStatus(currentPageInfo.status) || "" }}</span>
                </div>
              </div>
            </div>
            
            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">回寄快递:</div>
                <div class="right">
                  {{ currentPageInfo.backDeliveryName || "" }}
                </div>
              </div>
              <div class="item flexStyle2">
                <div class="left">回寄单号:</div>
                <div class="right">
                  {{ currentPageInfo.backDeliveryNum || "暂无" }}
                </div>
                <div
                  class="copy hands"
                  @click="copyText(currentPageInfo.backDeliveryNum)"
                >
                  复制
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="info">
          <div class="top">原订单信息</div>
          <div class="bottom">
            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">下单时间:</div>
                <div class="right">
                  {{ orderInfo.createTime || "暂无" }}
                </div>
              </div>
              <div class="item flexStyle2">
                <div class="left">订单状态:</div>
                <div class="right right1">
                  <span>{{ order_status(orderInfo.status) || "" }}</span>
                </div>
              </div>
            </div>

            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">运费:</div>
                <div class="right">
                  ¥{{ orderInfo.money_yun || "0.00" }}
                </div>
              </div>
              <div class="item flexStyle2">
                <div class="left">订单编号:</div>
                <div class="right">
                  {{ orderInfo.orderNum || "暂无" }}
                </div>
                <div
                  class="copy hands"
                  @click="copyText(orderInfo.orderNum)"
                >
                  复制
                </div>
              </div>
            </div>
            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">收货人:</div>
                <div class="right">
                  {{ orderInfo.consignee || "暂无" }}
                </div>
              </div>
              <div class="item flexStyle2">
                <div class="left">联系方式:</div>
                <div class="right">
                  {{ orderInfo.consigneePhone || "暂无" }}
                </div>
              </div>
            </div>
            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">收货地址:</div>
                <div class="right">
                  {{ orderInfo.province || ""
                  }}{{ orderInfo.city || ""
                  }}{{ orderInfo.area || ""
                  }}{{ orderInfo.addressDetail || "暂无" }}
                </div>
              </div>
            </div>

            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">订单商品:</div>
                <div class="right">
                  {{ orderInfo.goodsInfo || "暂无" }}
                </div>
              </div>
            </div>

            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">支付时间:</div>
                <div class="right">{{ orderInfo.payTime || "暂无" }}</div>
              </div>
              <div class="item flexStyle2">
                <div class="left">支付方式:</div>
                <div class="right">
                  <span v-if="orderInfo.payType == 0">余额</span>
                  <span v-else-if="orderInfo.payType == 1">微信</span>
                  <span v-else-if="orderInfo.payType == 2">支付宝</span>
                  <span v-else>暂无</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="info">
          <div class="top">退货收货人信息</div>
          <div class="bottom">
            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">收货人:</div>
                <div class="right">
                  {{ currentPageInfo.linkman || "暂无" }}
                </div>
              </div>
              <div class="item flexStyle2">
                <div class="left">联系方式:</div>
                <div class="right">
                  {{ currentPageInfo.phone || "暂无" }}
                </div>
              </div>
            </div>
            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">收货地址:</div>
                <div class="right">
                  {{ currentPageInfo.province || ""
                  }}{{ currentPageInfo.city || ""
                  }}{{ currentPageInfo.area || ""
                  }}{{ currentPageInfo.addressDetail || "暂无" }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="info">
          <div class="top">退货处理</div>
          <div class="bottom">
            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">处理人:</div>
                <div class="right">
                  {{ currentPageInfo.updateName || "" }}
                </div>
              </div>
              <div class="item flexStyle2">
                <div class="left">处理时间:</div>
                <div class="right">
                  {{ currentPageInfo.updateTime || "" }}
                </div>
              </div>
            </div>
            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">处理结果:</div>
                <div class="right">{{ currentPageInfo.result || "" }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="goBack">
        <el-button
          icon="el-icon-back"
          type="primary"
          size="small"
          style="width:90px;"
          @click="goBack"
        >
          返 回
        </el-button>
      </div>
    </div>
    <!-- 2.main-container-end -->

    <!-- 100.footer-container-start -->
    <c-footer></c-footer>
    <!-- 100.footer-container-end -->
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import tabbar from "../../components/tabbar/tabbar";
import footer from "../../components/footer/footer";
import {
  returnOrderDetailRequest,
  orderDetailRequest,
} from "../../public/js/service";

export default {
  data() {
    // 1.data
    return {
      currentPageInfo: {
        // 1.1.currentPageInfo
        orderItemList: [],
      },
      orderInfo: {},
      token: "", // 1.2.token
    };
  },

  components: {
    // 2.components
    tabbar, // 2.1.tabbar
    cFooter: footer, // 2.2.footer
  },

  methods: {
    // 3.methods
    copyText(value) {
      // 3.1.copyText
      let inputObject = document.createElement("input");
      document.body.appendChild(inputObject);
      inputObject.style.visibility = "none";
      inputObject.value = value;
      inputObject.select();
      document.execCommand("copy");

      this.$message({
        showClose: true,
        message: "已复制到剪切板",
        type: "success",
      });
      inputObject.style.display = "none";
    },

    getCurrentPageInfo() {
      // 3.2.获取信息
      returnOrderDetailRequest(this.orderId).then((res) => {
        if (res) {
          this.currentPageInfo = res.data || {};

          this.getOrderInfo(res.data.orderId);
        }
      });
    },
    getOrderInfo(orderId) {
      orderDetailRequest(orderId).then((res) => {
        if (res) {
          this.orderInfo = res.data;
        }
      });
    },

    goBack() {
      // 3.3.返回
      this.$router.go(-1);
    },
    mainTypeFormat(data) {
      let type = "";
      if (data === 0) {
        type = "补发";
      }
      if (data === 1) {
        type = "换货";
      }
      if (data === 2) {
        type = "退货";
      }
      return type;
    },
    itemTypeFormat(data) {
      let type = "";
      if (data === 0) {
        type = "其他";
      }
      if (data === 1) {
        type = "商品质量问题";
      }
      if (data === 2) {
        type = "缺少商品";
      }
      if (data === 3) {
        type = "商品与描述不符";
      }
      if (data === 4) {
        type = "发错商品";
      }
      return type;
    },
    getStatus(v) {
      let rr = ""; //0未审核1初审未通过2初审已通过3.复审未通过4.收货待确认5.发货待确认6.待核实7.已完成8.已取消
      let ary = [];
      ary.push({ id: 0, name: "待提报" });
      ary.push({ id: 1, name: "待审核" });
      ary.push({ id: 2, name: "待处理" });
      ary.push({ id: 3, name: "已处理" });
      ary.push({ id: 4, name: "已取消" });
      for (let i = 0; i < ary.length; i++) {
        if (ary[i].id == v) {
          rr = ary[i].name;
          break;
        }
      }
      return rr;
    },
  },

  mounted() {
    if (this.$route.query.orderId) {
      this.orderId = this.$route.query.orderId;

      if (localStorage.token) {
        this.token = localStorage.token;
        this.getCurrentPageInfo();
      }
    }
  },
};
</script>

<style scoped lang="scss">
@import "./returnOrderDetail.scss";
</style>
